import { memo, useEffect, useState } from "react"
import { CardVariant } from "../../models/CardVariant"
import { useSelector } from "react-redux"
import { RootState } from "../../store"
import Badge from "../../components/Badge/Badge"

export type DeckCardCountProps = {
    count: number,
    variant: CardVariant,
    showCollectionCount?: boolean,
    collection?: Record<string, number>,
    variantsBySerialDictionary: Record<string, CardVariant[]>
}

function DeckCardCount(props: DeckCardCountProps) {
    const isLoggedIn = useSelector<RootState, boolean>(x => x.user.isLoggedIn);

    const getNumberCollected = () => {
        if (!props.collection || !Object.keys(props.collection)?.length) {
            return 0;
        }

        const serialMatches = props.variantsBySerialDictionary[props.variant.serial];

        if (props.variant.altSerial) {
            const altSerialMatches = props.variantsBySerialDictionary[props.variant.altSerial] ?? [];

            for (const item of altSerialMatches) {
                if (serialMatches.find(x => x.id === item.id)) {
                    continue;
                }

                serialMatches.push(item);
            }
        }

        let collected = 0;
        for (const item of serialMatches) {
            const collectionCount = props.collection[item.id] ?? 0;
            collected += collectionCount;
        }

        return collected;
    }

    const [numberCollected, setNumberCollected] = useState(getNumberCollected());
    const [showCollectionCount, setShowCollectionCount] = useState(false);

    useEffect(() => {
        const newShowCollectionCount = isLoggedIn && !!props.showCollectionCount;
        setShowCollectionCount(newShowCollectionCount);

        if (!newShowCollectionCount || !props.collection || !Object.keys(props.collection)?.length) {
            return;
        }

        setNumberCollected(getNumberCollected());
    }, [props.collection, props.showCollectionCount, isLoggedIn]);

    return (
        <div className="flex">
            <div className="text-gray-400 min-w-[31px] text-center" style={{ fontWeight: 900, fontSize: "3rem", lineHeight: .75 }}>
                {props.count}
            </div>
            {
                showCollectionCount &&
                <Badge color={ numberCollected >= props.count ? "success" : "default" } title="# Collected" className="self-end ml-1">
                    {numberCollected}
                </Badge>
            }
        </div>
    )
}

export default memo(DeckCardCount);